import React, { useState } from 'react';
import { KeyboardBackspace } from "@mui/icons-material";
import Box from "components/inputs/Box";
import Button from "components/inputs/Button";
import AccountForm from "components/form/AccountForm";

import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { accountActions } from "reducers/account";
import AccountService from "service/apiConfig/AccountService";
import { accountValidation } from "../../service/validation/accountValidation";

const AccountCreate = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [input, setInput] = useState({
        id: null,
        role: null,
        username: "",
        name: "",
        password: "",
        passwordConfirm: "",
    })
    const { role, name, username, password, passwordConfirm } = input;

    const onSaveAccount = (e) => {
        e.preventDefault();
        let data = {
            "role": { id: role },
            "id": null,
            "name": name,
            "username": username,
            "password": password,
            "passwordConfirm": passwordConfirm,
        };
        AccountService.create(data)
            .then(response => {
                accountValidation(response);
            })
            .catch(err => console.log(err));
    }
    const goBack = () => {
        history.goBack();
        dispatch(accountActions.setAccountDetail({
            id: null,
            role: null,
            username: "",
            name: "",
            password: "",
            passwordConfirm: "",
        }));
    }

    return (
        <section className={`sectionWrap`}>
            <header>
                <h2>계정 등록</h2>
                <button onClick={goBack}><KeyboardBackspace /></button>
            </header>
            <Box>
                <AccountForm input={input} setInput={setInput} create={true} />
                <div style={{ display: "flex" }}>
                    <Button onClick={onSaveAccount} style={{ marginLeft: "auto", background: "#5a54a1" }}>등록</Button>
                </div>
            </Box>
        </section>
    );
};

export default AccountCreate;